// Sada inline SVG ikon (bez externých knižníc – rýchle a prístupné).
// Použitie: <Icon name="bed" />  – ikony sú dekoratívne (aria-hidden).

import React from 'react';

const paths = {
  bed: <path d="M3 18v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8M3 18h18M3 18v2m18-2v2M7 8V6h10v2" />,
  seat: <path d="M7 4v9h9l3 7M7 13l-2 7m3-16h6" />,
  kitchen: <path d="M4 4h16v16H4zM4 10h16M9 14h.01M15 14h.01" />,
  fridge: <path d="M6 3h12v18H6zM6 10h12M9 6v2M9 13v3" />,
  water: <path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z" />,
  heating: <path d="M8 4c0 2-2 3-2 5s2 3 2 5m4-10c0 2-2 3-2 5s2 3 2 5m4-10c0 2-2 3-2 5s2 3 2 5M5 20h14" />,
  roof: <path d="M3 14l9-7 9 7M5 14v5h14v-5" />,
  gearbox: <path d="M6 5v14M12 5v7M18 5v7M6 12h12M6 5h.01M12 5h.01M18 5h.01" />,
  navigation: <path d="M12 2l7 19-7-5-7 5 7-19z" />,
  chair: <path d="M6 4v9h9M6 13l-2 8m5-8v8m6-8 3 8M8 8h7" />,
  table: <path d="M4 8h16M6 8l-2 12M18 8l2 12M12 8v6" />,
  plug: <path d="M9 3v5m6-5v5M7 8h10v3a5 5 0 0 1-10 0V8zM12 16v5" />,
  usb: <path d="M12 2v14m0 0-4-3m4 3 4-4M12 2l-2 3h4l-2-3zM12 19a2 2 0 1 0 0 3 2 2 0 0 0 0-3z" />,
  check: <path d="M4 12l6 6L20 6" />,
  cross: <path d="M6 6l12 12M18 6L6 18" />,
  star: <path d="M12 3l2.7 5.8 6.3.7-4.7 4.3 1.3 6.2-5.6-3.2L6.4 20l1.3-6.2L3 9.5l6.3-.7L12 3z" />,
  phone: <path d="M5 4h4l2 5-2.5 1.5a12 12 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />,
  mail: <path d="M3 6h18v12H3zM3 7l9 6 9-6" />,
  pin: <path d="M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11zm0-9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />,
  whatsapp: <path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3zm-3 5.5c.3-.7.7-.7 1-.7l.8.1c.2.1.5.8.6 1.1 0 .3 0 .6-.2.8l-.5.6c.2.5.9 1.5 1.7 2.1.9.7 1.6.9 2 1l.6-.6c.2-.2.5-.3.8-.2l1.6.8c.3.1.4.3.4.5-.1.5-.6 1.5-1.6 1.7-.9.2-2.1.1-3.9-1a10.5 10.5 0 0 1-3.6-3.9c-.6-1.1-.6-2 0-3z" />,
  calendar: <path d="M4 6h16v15H4zM4 10h16M8 3v4m8-4v4" />,
  route: <path d="M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm12-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 17h7a3 3 0 0 0 0-6H9a3 3 0 0 1 0-6h7" />,
  download: <path d="M12 3v12m0 0-5-5m5 5 5-5M4 21h16" />,
  chevron: <path d="M6 9l6 6 6-6" />,
  arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
  users: <path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8 0a3 3 0 1 0-2-5.2M3 20a6 6 0 0 1 12 0m2-6a6 6 0 0 1 4 6" />,
  fuel: <path d="M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M3 21h14M15 9h2a2 2 0 0 1 2 2v6a1.5 1.5 0 0 0 3 0V9l-3-3M7 7h6v4H7z" />,
  clock: <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-13v5l3 3" />,
};

export default function Icon({ name, size = 24, strokeWidth = 1.8, className = '', ...rest }) {
  return (
    <svg
      {...rest}
      className={`icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {paths[name] || null}
    </svg>
  );
}
